import { useHealthblocksSWR } from '@healthblocks-io/core'
import { useLingui } from '@lingui/react'

const immutable = {
  dedupingInterval: 60000,
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
}

export type Translation = {
  key: string
  values: { nl: ''; en: '' }
}

export function useTranslations() {
  const translations = useHealthblocksSWR<Translation[]>('/translation', immutable)
  return translations.data
}

export function useTranslated(key: string) {
  const language = useLingui().i18n.locale as 'nl' | 'en'
  const translations = useHealthblocksSWR<Translation[]>('/translation', immutable)
  return translations.data?.find((t) => t.key === key)?.values[language] || ''
}
